import { render, staticRenderFns } from "./RegionItem.vue?vue&type=template&id=3711a604&scoped=true&"
import script from "./RegionItem.vue?vue&type=script&lang=js&"
export * from "./RegionItem.vue?vue&type=script&lang=js&"
import style0 from "./RegionItem.vue?vue&type=style&index=0&id=3711a604&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3711a604",
  null
  
)

export default component.exports